import * as React from "react";
import { formSet, formSetValue, useCpFormValue } from "./utils";
import { store } from "../../../store";
import { CheckCircleFilled } from "@ant-design/icons";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface RadioCardOption {
  value: string | boolean;
  label: string;
  disabled?: boolean;
  boldLabel?: boolean;
  children: React.ReactNode;
}

interface Props {
  name: string;
  options: RadioCardOption[];
  vertical?: boolean;
  grid?: boolean;
  gridCols?: number;
}
export const CpRadioCardGroup = (props: Props): React.ReactElement => {
  const { id } = useCpFormContext();

  const { name, grid, gridCols = 2, vertical, options } = props;

  const value = useCpFormValue(name);

  React.useEffect(() => {
    formSet(id, `${fieldStatePath}.visited`, true);
    formSet(id, `${fieldStatePath}.touched`, true);
  }, []);

  const fieldStatePath = React.useMemo(() => `fieldStates.${name}`, [name]);

  return (
    <div className={`gap-4 ${grid ? `grid grid-cols-${gridCols}` : `flex ${vertical ? "flex-col" : ""}`}`}>
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <div
            key={String(option.value)}
            className={`mb-2 p-4 border ${
              option.disabled ? "cursor-not-allowed radio-card-disabled" : "cursor-pointer"
            } radio-card ${isSelected ? "radio-card-active" : ""}`}
            style={{ minWidth: 100, borderRadius: 6 }}
            onClick={() => {
              if (option.disabled) {
                return;
              }

              formSetValue(id, name, option.value);
              formSet(id, `${fieldStatePath}.focused`, true);
              formSet(id, `${fieldStatePath}.modified`, true);

              const form = store.getState().form.instances[id];

              const onChangeCounter = form.meta.onChangeCounter;
              formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);

              const onBlurCounter = form.meta.onBlurCounter;
              formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
            }}
          >
            <div className="flex items-center gap-2">
              <div className={`${option.boldLabel ? "font-semibold" : ""}`}>{option.label}</div>
              {isSelected ? <CheckCircleFilled className="color-action h-4" /> : null}
            </div>
            {option.children}
          </div>
        );
      })}
    </div>
  );
};
